<div class="container">
  <div class="row">
    <div class="col-main col-lg-4 col-sm-6 ms-auto me-auto">
      <div class="card card-register">
        <h3 class="title">{{title|traduccion}}</h3>
        <form class="register-form" [formGroup]="form" (ngSubmit)="submitForm()">

          @if (mode=='reset') {
            <div>
              <label>{{'email'|traduccion}}</label>
              <div class="input-group form-group-no-border" [ngClass]="{'input-group-focus':focus===true}">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="nc-icon nc-email-85"></i>
                  </span>
                </div>
                <input formControlName="email" id="name" name="email" type="text" class="form-control" placeholder="{{'email'|traduccion}}"
                  (focus)="focus=true" (blur)="focus=false">
                </div>
                @if (email.invalid && (email.dirty || email.touched)) {
                  <div class="text-danger">
                    @if (email.errors.required) {
                      <small>{{'email.errors.required'|traduccion}}<br></small>
                    }
                    @if (email.errors.email) {
                      <small>{{'email.errors.email'|traduccion}}<br></small>
                    }
                  </div>
                }
              </div>
            }

            @if (mode=='change') {
              <div>
                <label>{{'password'|traduccion}}</label>
                <div class="input-group form-group-no-border" [ngClass]="{'input-group-focus':focus1===true}">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="nc-icon nc-key-25"></i>
                    </span>
                  </div>
                  <input formControlName="newPassword" name="newPassword" type="password" class="form-control" placeholder="{{'password'|traduccion}}"
                    (focus)="focus1=true" (blur)="focus1=false">
                  </div>
                  <!-- Barra visual -->
                  @if (passwordStrength > 0) {
                    <div class="strength-bar">
                      <div
                        class="strength"
                [ngClass]="{
                  'weak': passwordStrength <= 2,
                  'medium': passwordStrength === 3 || passwordStrength === 4,
                  'strong': passwordStrength === 5
                }"
                        [style.width.%]="passwordStrength * 20">
                      </div>
                    </div>
                  }
                  @if (passwordStrength > 0) {
                    <p class="mt-1">
                      Fortaleza:
              <span class="badge" [ngClass]="{
                'badge-danger': passwordStrength <= 2,
                'badge-warning': passwordStrength === 3 || passwordStrength === 4,
                'badge-success': passwordStrength === 5
              }">
                        {{ passwordStrength <= 2 ? 'Débil' : passwordStrength < 5 ? 'Media' : 'Fuerte' }}
                      </span>
                    </p>
                  }
                  <!-- Mensajes detallados -->
                  @if (newPassword?.touched && newPassword?.invalid) {
                    <div class="text-danger">
                      @if (newPassword.errors.required) {
                        <small>{{'password.errors.required'|traduccion}}<br></small>
                      }
                      @if (newPassword?.errors?.['minLength']) {
                        <small>{{'password.errors.minlength'|traduccion}}<br></small>
                      }
                      @if (newPassword?.errors?.['missingLowercase']) {
                        <small>{{'password.errors.missingLowercase'|traduccion}}<br></small>
                      }
                      @if (newPassword?.errors?.['missingUppercase']) {
                        <small>{{'password.errors.missingUppercase'|traduccion}}<br></small>
                      }
                      @if (newPassword?.errors?.['missingDigit']) {
                        <small>{{'password.errors.missingDigit'|traduccion}}<br></small>
                      }
                      @if (newPassword?.errors?.['missingSpecial']) {
                        <small>{{'password.errors.missingSpecial'|traduccion}}<br></small>
                      }
                    </div>
                  }
                  <label>{{'passwordConfirm'|traduccion}}</label>
                  <div class="input-group form-group-no-border" [ngClass]="{'input-group-focus':focus1===true}">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="nc-icon nc-key-25"></i>
                      </span>
                    </div>
                    <input formControlName="passwordConfirm" name="passwordConfirm" type="password" class="form-control" placeholder="{{'passwordConfirm'|traduccion}}"
                      (focus)="focus1=true" (blur)="focus1=false">
                    </div>
                    @if (form.hasError('passwordMismatch') && form.get('passwordConfirm')?.touched) {
                      <div class="text-danger">
                        <small>{{'password.errors.passwordNotMatch'|traduccion}}</small>
                      </div>
                    }
                  </div>
                }
                <button [disabled]="!form.valid || sent" class="btn btn-outline-neutral btn-block btn-round">{{'reset_password'|traduccion}}</button>
              </form>
              <div class="forgot">
                <a (click)="_goTo('signin')" class="btn btn-link btn-terciary">{{'signin'|traduccion}}</a>
              </div>
            </div>
          </div>
        </div>
        <div class="footer register-footer text-center">

        </div>
      </div>